import { Routes } from '@angular/router';

import { applicationPaths } from './constants';

export const routes: Routes = [
  {
    path: applicationPaths.register,
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: applicationPaths.profile,
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: applicationPaths.login,
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: applicationPaths.loginFailed,
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: applicationPaths.loginCallback,
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: applicationPaths.logOut,
    loadComponent: () => import('./components/logout/logout.component').then(m => m.LogoutComponent),
  },
  {
    path: applicationPaths.loggedOut,
    loadComponent: () => import('./components/logout/logout.component').then(m => m.LogoutComponent),
  },
  {
    path: applicationPaths.logOutCallback,
    loadComponent: () => import('./components/logout/logout.component').then(m => m.LogoutComponent),
  },
  {
    path: applicationPaths.marketingPreferences,
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: applicationPaths.crmSystemInformation,
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
];
